// Classes.
import { BaseLocator } from "./../locators/base.locator";
import { StringLocatorComponent } from "./../locators/string.locator-component";
import { CategoryLocatorComponent } from "./../locators/category.locator-component";
import { CardinalityLocatorComponent } from "./../locators/cardinality.locator-component";
import { DateLocatorComponent } from "./../locators/date.locator-component";
import { DetailedLocatorComponent } from "./../locators/detailed.locator-component";
import { YearLocatorComponent } from "./year.locator-component";
import { RankSortingLocatorComponent } from "./indoor-sorting-locator";

export class WorldRankingLocator extends BaseLocator {
  public name: StringLocatorComponent;
  public category: CategoryLocatorComponent;
  public team: CardinalityLocatorComponent;
  public date: DateLocatorComponent;
  public detailed: DetailedLocatorComponent;
  public year: YearLocatorComponent;
  public sortrank: RankSortingLocatorComponent;
  public search: StringLocatorComponent;
  public country: StringLocatorComponent;

  constructor() {
    super("worldRankingList");
    this.addComponentByType("category");
    this.addComponentByType("team");
    this.addComponentByType("date");
    this.addComponentByType("detailed");
    this.addComponentByType("year");
    this.addComponentByType("sortrank", "sortrank");
    this.addComponentByType("search");
    this.addComponentByType("country", "country")
  }
}
